import { apiRequest } from './httpClient';

// AI meeting memory / semantic search (backend/services/meeting_memory.py,
// backend/routers/memory.py) — both endpoints are user_id-scoped
// server-side; there is no client-side filtering to get right or get
// wrong here.

export function searchMemory(query, { limit = 10 } = {}) {
  const params = new URLSearchParams();
  params.set('q', query);
  params.set('limit', limit);

  return apiRequest(`/api/memory/search?${params.toString()}`);
}

export function askMemory(question) {
  return apiRequest('/api/memory/ask', {
    method: 'POST',
    body: { question },
  });
}

// Past Ask KrishvaQ questions, newest first (backend GET
// /api/memory/history). Written server-side by every /ask, so there is
// nothing to POST here — history is a read-only view of what the user
// has already asked.
export function getHistory({ limit = 20 } = {}) {
  const params = new URLSearchParams();
  params.set('limit', limit);

  return apiRequest(`/api/memory/history?${params.toString()}`);
}
